// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"a6c1c36c","835":"7a8cce35"}[chunkId] + ".chunk.css";
};